import { Component, OnInit, NgModule, ViewChild, Output, EventEmitter,Input } from '@angular/core';
import { HourglassService } from 'src/app/services/hourglass.service';
import { TabTasksGridComponent } from './tab-tasks-grid/tab-tasks-grid.component';
import { TabEntryComponent } from './tab-entry/tab-entry.component';
import { TabHelpComponent } from './tab-help/tab-help.component';
import { AppModule } from '../../../app.module';
import * as dayjs from 'dayjs';
import * as weekfinder from 'dayjs/plugin/weekOfYear';
import { TabCalendarComponent } from './tab-calendar/tab-calendar.component';
import { TabSendWeeklyUpdateComponent } from './tab-send-weekly-update/tab-send-weekly-update.component';
import { TabCalendarMultiComponent } from './tab-calendar-multi/tab-calendar-multi.component';
import { TabBillingReviewGridComponent } from './tab-billing-review-grid/tab-billing-review-grid.component';
import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute } from '@angular/router';

dayjs.extend(weekfinder);

@Component({
  selector: 'app-hourglass',
  templateUrl: './hourglass.component.html',
  styleUrls: ['./hourglass.component.css']
})
export class HourglassComponent implements OnInit {
  @ViewChild(TabTasksGridComponent) tabTasks!: TabTasksGridComponent;
  @ViewChild(TabEntryComponent) tabEntry!: TabEntryComponent;
  @ViewChild(TabCalendarComponent) tabCalendar!: TabCalendarComponent;
  @ViewChild(TabCalendarMultiComponent) tabCalendar2!: TabCalendarMultiComponent;
  @ViewChild(TabSendWeeklyUpdateComponent) tabWeekly!: TabSendWeeklyUpdateComponent;
  @ViewChild(TabHelpComponent) tabHelp!: TabHelpComponent;
  @ViewChild(TabBillingReviewGridComponent) tabGridReview!: TabBillingReviewGridComponent;
  @Input() inputTab!: string | undefined;
  token!: string;
  columnDefs: any[] = [];
  error_msg = "";
  params: any;
  rowData: any[] = [];
  listEmployees: any[] = [];
  saveMode = "add";
  searchText = "";
  //JASON TO ASK DUNCAN ABOUT HOW IMPERSONATION WILL EFFECT LOCAL STORAGE AND IF WE CAN FAZE OUT
  userID: any = sessionStorage.getItem('wOSImpersonate') || sessionStorage.getItem('wOSAuthUser') || "";
  authUser: any = sessionStorage.getItem('wOSAuthUser');
  authAdmin: any = sessionStorage.getItem('wOSAdmin');
  impersonatedUser: any = this.userID;
  currentTab = "entry";
  tabBillingReviewGrid: any;
  userRole: number | null = null;

  constructor(
    private route: ActivatedRoute,
    private hourglassService: HourglassService,
    private appModule: AppModule,
    private authService: AuthService
  ) {
  }

  ngOnInit(): void {
    this.authService.getUserRole().subscribe(role => {
      this.userRole = role;
    });
    const impUser = sessionStorage.getItem("wOSImpersonate");

    if (impUser != null) 
      this.impersonateUser(impUser)
    
    const user: any = sessionStorage.getItem("wOSUser");
    this.token = JSON.parse(user).stsTokenManager.accessToken;

    $('#mainTabs').on('shown.bs.tab', (event) => {
      this.currentTab = event.target.id.replace('-tab', '');
      switch (this.currentTab) {
        case 'entry':
          this.tabEntry.gridApi.setGridOption('loading', true);
          this.tabEntry.getUXData(this.userID, "all");
          setTimeout(() => {
            this.tabEntry.setFromImpersonate(this.userID);
          }, 500)
          break;
        case 'calendar':
          if (this.tabCalendar) {
            this.tabCalendar.loadCSharpEvents();
          }
          break;
        case 'calendar2':
          if (this.tabCalendar2) {
            this.tabCalendar2.updateCalendarEvents();
          }
          break;
        case 'tasks':
          this.tabTasks.gridApi.setGridOption('loading', true);
          this.tabTasks.getUXData(this.impersonatedUser, "tasks", this.token);
          break;
        case 'submitweekly':
          this.tabWeekly.userID = this.impersonatedUser;
          this.tabWeekly.loadFromEntryTab();
          break;
        default:
          break;
      }
      let settings: any = "";
      this.hourglassService.getUserMetadata(this.userID, this.token).then(r => {
        sessionStorage.setItem('wOSUserPrefs', JSON.stringify(r[0]));
        settings = r[0];
      })
    })

    setTimeout(() => {
      this.route.paramMap.subscribe(params => {
        const tab = (this.inputTab == undefined) ? params.get('tab') : this.inputTab;
        console.log("tab", tab, params)
        if (tab == 'tools')
          $('#export-tab').trigger('click');
      })
    })
  }

  setImpersonateFilterValues(params: any): void {
    this.listEmployees = params;
  }

  trackByFn(index: any, record: any) {
    return record.id
  }

  impersonateUser(params: any): void {
    $('body,.sidebar').css({ "background": "var(--welaraorangelt)" })
    this.impersonatedUser = params.target.value | params;
    sessionStorage.setItem("wOSImpersonate", this.impersonatedUser);
    console.log("impersonateUser", this.impersonatedUser)
    switch (this.currentTab) {
      case 'entry':
        this.tabEntry.impersonatedUser = this.impersonatedUser;
        this.tabEntry.userID = this.impersonatedUser;
        this.tabEntry.gridApi.setGridOption('loading', true);
        this.tabEntry.formEntry.entryForm.employeeID = this.impersonatedUser;
        this.tabEntry.getUXData(this.impersonatedUser, "all");
        break;
      case 'calendar':
        if (this.tabCalendar) {
          this.tabCalendar.updateCalendarEvents();
        }
        break;
      case 'tasks':
        this.tabTasks.gridApi.setGridOption('loading', true);
        this.tabTasks.getUXData(this.impersonatedUser, "tasks", this.token);
        break;
      case 'submitweekly':
        this.tabWeekly.userID = this.impersonatedUser;
        this.tabWeekly.loadWeekData(null);
        break;
      default:
        break;
    }
  }

  killImpersonate(): void {
    $('body,.sidebar').css({ "background-color": "var(--welaratimberwolf)" });
    sessionStorage.removeItem('wOSImpersonate');
    const test = confirm("You are stopping impersonation.  Any unsaved changes will be lost.  Continue?");
    if (test) window.location.reload();
  }
}
